export default __webpack_public_path__ + "static/media/avatar.4e112ac9.jpg";